import React from 'react'

import { Wistia } from '../../../storybook'
import Image from 'next/image'
import { Image as DatoImage } from 'react-datocms'

// Image or Video (Wisitia)
export const MediaComponent = ({ height, width, image, wistiaVideo, preview }) => {
  const isMediaMP4 = image?.mimeType === 'video/mp4'

  const mp4Background = isMediaMP4 && wistiaVideo && wistiaVideo?.videoId
  let mp4Video = null

  if (isMediaMP4) {
    if (mp4Background) {
      mp4Video = (
        <video
          key={image?.title}
          loop
          playsInline
          autoPlay
          muted
          aria-label="Video Player"
          style={{ width: '100%' }}
        >
          <source src={image?.url} type="video/mp4" />
          <track kind="captions" />
        </video>
      )
    } else {
      return (
        <video
          key={image?.title}
          loop
          playsInline
          autoPlay
          muted
          aria-label="Video Player"
          style={{ width: '100%' }}
        >
          <source src={image?.url} type="video/mp4" />
          <track kind="captions" />
        </video>
      )
    }
  }

  if (wistiaVideo && wistiaVideo?.videoId) {
    return (
      <Wistia
        videoSource={wistiaVideo.videoSource}
        videoId={wistiaVideo.videoId}
        thumbnailVideo={!!mp4Video}
        thumbnail={mp4Video || wistiaVideo?.thumbnail || image || null}
        playText={wistiaVideo?.playText}
      />
    )
  }
  if (preview && image?.url) {
    return <Image src={image?.url} height={height} width={width} />
  }

  if (image.responsiveImage) {
    return <DatoImage data={image.responsiveImage} />
  }

  if (image.url) {
    return <Image src={image.url} height={height} width={width} />
  }

  return null
}
